<template>
	<div class="columns is-mobile is-gapless is-vcentered mx-auto">
		<span class="column is-narrow" v-if="isMultipleImages">
			<button @click="prev" class="navigationBtn material-icons is-size-6-mobile is-size-3-tablet" :disabled="currentSlide === 0">keyboard_arrow_left</button>
		</span>
		<div class="column">
			<carousel ref="carousel" v-model="currentSlide">
				<slide v-for="(img, index) in imagesList" :key="index" @click="onImageClick(img)" class="px-1">
					<img :src="img" class="image main-image" :class="{'is-clickable': isImageClickable}"/>
				</slide>
			</carousel>
		</div>
		
		<span class="column is-narrow" v-if="isMultipleImages">
			<button @click="next" class="navigationBtn material-icons is-size-6-mobile is-size-3-tablet" :disabled="currentSlide === (images.length - 1)">keyboard_arrow_right</button>
		</span>
	</div>
	
	<template v-if="isMultipleImages && withThumbnails">
		<Carousel
			class="thumbnails mx-auto mb-2"
			:items-to-show="imagesList?.length"
			v-model="currentSlide"
		>
			<Slide v-for="(img, index) in imagesList" :key="index">
				<div @click="slideTo(index)" class="is-clickable p-2">
					<img :src="img" width="60px" height="60px"/>
				</div>
			</Slide>
		</Carousel>
	</template>

</template>
<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

export default defineComponent({
	props: { 
		initialIndex: {
			type: Number,
			default: 0
		},
		images: {
			type: [Array, String] as PropType<string[] | string>,
			required: true
		},
		withThumbnails: {
			type: Boolean
		},
		onImageClick: {
			type: Function,
			default: () => {}
		}
	},
	data () {
		return { 
			currentSlide: this.initialIndex
		}
	},
	components: { Carousel, Slide },
	computed: {
		isImageClickable (): boolean {
			return typeof this.onImageClick === 'function'
		},
		imagesList () : string[] {
			if (!this.images) return [];
			if (Array.isArray(this.images)) {
				return this.images;
			}
			return [this.images]
		},
		isMultipleImages (): boolean {
			return this.imagesList.length > 1;
		}
	},
	methods: {
		slideTo (idx: number) {
			this.currentSlide = idx
		},
		next () {
			(this.$refs.carousel as any).next();
		},
		prev () {
			(this.$refs.carousel as any).prev()
		}
	}
})
</script>

<style scoped>
.columns {
	min-height: 30vh;
	max-width: 100%;
	max-height: 70vh;
}

.thumbnails { 
	width: fit-content;
	max-width: 100%;
}

.thumbnails img {
	max-height: 70px;
}

.main-image {
	max-width: 100%!important;
	max-height: 300px!important;
}

.navigationBtn:disabled {
	color: gray;
}

@media (max-width: 768px) { 
	.columns {
		max-height: 50vh;
	}

	.main-image {
		max-height: 200px!important;
	}
}
</style>
